import { useStaticQuery, graphql } from 'gatsby';

type OutOfStockProduct = {
  productId: number;
  slug: string;
};

const useOutOfStockProducts = (): OutOfStockProduct[] => {
  const result: Queries.useOutOfStockProductsQuery = useStaticQuery(graphql`
    query useOutOfStockProducts {
      allContentfulProduct001(
        filter: {
          metadata: {
            flags: {
              elemMatch: {
                metadata: { metadata_id: { eq: "outOfStock" } }
                value: { eq: true }
              }
            }
          }
        }
      ) {
        nodes {
          slug
          spreeProduct {
            productId
          }
        }
      }
    }
  `);

  return result.allContentfulProduct001.nodes.map((node) => ({
    slug: node.slug as string,
    productId: node.spreeProduct?.productId as number,
  }));
};

export default useOutOfStockProducts;
